import { createSelector } from 'reselect';
import { getLoggedInUser } from 'src/modules/login/selectors/getLoggedInUser';
import { getSortedFoundUsers } from 'src/modules/users/selectors/getSortedFoundUsers';

export const getSortedFoundSelectableUsers = createSelector(
  [getSortedFoundUsers, getLoggedInUser],
  (sortedFoundUsers, loggedInUser) => sortedFoundUsers.filter((user) => user.id !== loggedInUser.id),
);
